import $ from "jquery";
import BoolTimer from "../util/BoolTimer";
import messageResource from "../messageResource";
import {KEY_CODE_ENTER, KEY_CODE_UP, KEY_CODE_DOWN, KEY_CODE_TAB} from "../keyCodes";
import sessionTokenStore from "./GooglePlacesSessionTokenStore";

export default function CitiesSearchController()
{
}

CitiesSearchController.prototype.init = function(searchField, onSelectedRowAction, onStartSearchCallback, onRequestSuccessCallback, onRequestErrorCallback, isShowToTop, additionalClasses, preventDefaultTabMoving)
{
    this.onRequestErrorCallback = onRequestErrorCallback;
    this.onRequestSuccessCallback = onRequestSuccessCallback;
    this.onStartSearchCallback = onStartSearchCallback;
    this.onSelectedRowAction = onSelectedRowAction;

    this.isShowToTop = isShowToTop; // determines that need to show panel from search field to top or bot
    this.additionalClasses = additionalClasses;

    this.searchField = searchField;
    this.searchField.on("keydown", $.proxy(this._onSearchFieldKeyDownEvent, this)); // add events to search field
    this.preventDefaultTabMoving = preventDefaultTabMoving;
    this.containerElementId = "citiesSearchContainerElementId";

    this.hide();

    // google service for auto complete user search
    this.autocompliteService = new window.google.maps.places.AutocompleteService();

    var emptyContainer = $("<div></div>").hide();
    this.searchField.after(emptyContainer);
    // google service for get detailed information about city
    this.placesService = new window.google.maps.places.PlacesService(emptyContainer[0]);

    this.hoverEnabled = new BoolTimer(true, 500);

    return this;
};

CitiesSearchController.prototype.show = function()
{
    var searchFieldOffset = this.searchField.offset(); // get left top offset of search field
    var searchFHeightWithBorders = this.searchField.outerHeight();
    var searchFBorders = (searchFHeightWithBorders - this.searchField.innerHeight()) / 2;

    var containerOffset = searchFieldOffset;

    var container = this._getContainer();

    if(this.additionalClasses)
    {
        container.toggleClass(this.additionalClasses, true);
    }

    container.show(); // show (now we can calculate panel height)

    var heightOfContainer = container.innerHeight(); // get height og container

    var containerOffsetForShowToTop = containerOffset.top - searchFBorders - heightOfContainer; // move on the width of border of search field to top, move on the height of container
    var containerOffsetForShowToBottom = containerOffset.top + searchFHeightWithBorders; // // move panel on the height of search field height to bot

    var windowHeight = $(window).height();
    var windowScrollTop = $(window).scrollTop();

    // check that there is enough place for show panel
    var isEnoughPlaceForShowToTop = containerOffsetForShowToTop >= windowScrollTop ;
    var isEnoughPlaceForShowToBottom = (containerOffsetForShowToBottom + heightOfContainer) <= (windowHeight + windowScrollTop);

    var showToTop = this.isShowToTop; // set recommended value
    if(this.isShowToTop)
    {
        // show to top if possible otherwise to bot if possible
        showToTop = isEnoughPlaceForShowToTop || (!isEnoughPlaceForShowToBottom && !isEnoughPlaceForShowToTop);
    }
    else
    {
        // show to bottom if possible otherwise to top if possible
        showToTop = !isEnoughPlaceForShowToBottom && (isEnoughPlaceForShowToBottom || isEnoughPlaceForShowToTop);
    }

    containerOffset.top = showToTop ? containerOffsetForShowToTop : containerOffsetForShowToBottom;
    container.offset(containerOffset); // move to needed position
    this.isShown = true;
    this.userActivitiesEnabled = true;
};

CitiesSearchController.prototype.hide = function()
{
    var container = this._getContainer();
    if(this.additionalClasses)
    {
        container.toggleClass(this.additionalClasses, false);
    }
    container.hide();

    this.isShown = false;
    this.userActivitiesEnabled = false;
};

CitiesSearchController.prototype.getSearchPanelElement = function()
{
    return this._getContainer();
};

CitiesSearchController.prototype.isShow = function()
{
    return this.isShown;
};

/**
 * return container that will be inserted to dom
 * if element not founded - create new (lazy init)
 *
 * @returns {*|jQuery|HTMLElement}
 * @private
 */
CitiesSearchController.prototype._getContainer = function()
{
    var container = $.find("#"+this.containerElementId);
    if(container.length == 0)
    {
        var containerCls = "searchResultContainer" + " " + (this.isShowToTop ? "toTop" : "toBottom" );
        container = $("<div id='" + this.containerElementId+ "' class='" + containerCls + "'></div>");
        $("body").append(container); //append to body
    } else {
        container = $(container[0]);
    }
    return container;
};

/**
 * append formatted implementation of result data
 * @param citiesData data with cities from auto complete service
 * @param container
 * @private
 */
CitiesSearchController.prototype._appendCitiesRows = function(citiesData, container)
{
    var self = this;
    var citiesList = citiesData;

    for (var i = 0; i < citiesList.length; i++)
    {
        var data = citiesList[i];
        var row = this._createCityRow(data);

        row.on("click",
            function(rData)
            {
                return function(ev)
                {
                    self._onRowClick(rData);
                    ev.stopPropagation();
                };
            }(data)
        );
        row.on("mousemove",
            function(r)
            {
                return function(ev)
                {
                    self._onRowMouseMove(r);
                    ev.preventDefault();
                };
            }(row)
        );
        container.append(row);

        if (i == 0)
        {
            this._setActiveRow(row);
        }
    }
};

CitiesSearchController.prototype._onRowClick = function(cityData)
{
    this._stopTimer();
    this.userActivitiesEnabled = false;
    this.processGetDetailedCityInformation(cityData);
};

CitiesSearchController.prototype._onRowMouseMove = function(row)
{
    if (this.hoverEnabled.isTrue() && this.userActivitiesEnabled)
        this._setActiveRow(row);
};


CitiesSearchController.prototype._createCityRow = function(cityData)
{
    var row = $("<div class='row'></div>");
    var matchedSubstrings = cityData.matched_substrings;

    var cityName = $("<div class='cityName'></div>");
    cityName.append(this._highlightText(cityData.terms[0], matchedSubstrings));// call highlighting for city name

    var descriptionEl = $("<div class='divisionName'></div>");
    var country = cityData.terms[2];
    if (country)
    {
        descriptionEl.append(this._highlightText(country, matchedSubstrings));
    }
    if (cityData.terms[2] && cityData.terms[1])
    {
        descriptionEl.append(" / ");
    }
    var firstAdmin = cityData.terms[1];
    if (firstAdmin)
    {
        descriptionEl.append(this._highlightText(firstAdmin, matchedSubstrings));
    }

    row.append(cityName).append(descriptionEl);
    return row;
};

/**
 * For more information see google.maps.places.AutocompletePrediction object specification
 * @param term current term (part of founded description)
 * @param matchedSubStrings (array of all matches elements offset in description + length)
 * @returns {*|jQuery|HTMLElement} span with result
 * @private
 */
CitiesSearchController.prototype._highlightText = function(term, matchedSubStrings)
{
    var termOffset = term.offset;
    var termValue = term.value;

    // find substring for term
    var matchedSubstring;
    for (var i = 0; i < matchedSubStrings.length; i++)
    {
        var subOffset = matchedSubStrings[i].offset;
        if (termOffset <= subOffset && subOffset < termOffset + termValue.length)
        {
            matchedSubstring = matchedSubStrings[i];
        }
    }

    var result = $("<span></span>");
    var highResult = $("<span class='highlighted'></span>");
    // if matched substring founded - to highlight otherwise append simple value
    if (matchedSubstring)
    {
        var offsetFromTerm = matchedSubstring.offset - termOffset;
        result.append(termValue.substring(0, offsetFromTerm));
        result.append(highResult.append(termValue.substring(offsetFromTerm, offsetFromTerm + matchedSubstring.length)));
        result.append(termValue.substring(offsetFromTerm + matchedSubstring.length));
    }
    else
    {
        result.append(termValue);
    }

    return result;
};

CitiesSearchController.prototype._getEmptyResultRow = function()
{
    return $("<div class='emptyResultRow'>" + messageResource.getMessage("cities_search_panel.js.there_are_no_results") + "</div>");
};

CitiesSearchController.prototype._getPanelFooter = function()
{
    return $("<div class='footer'></div>");
};

CitiesSearchController.prototype._onSearchFieldKeyDownEvent = function(event)
{
    if (event.keyCode == KEY_CODE_UP)
    {
        this._moveCursorUpOrDown(true);
        event.preventDefault();
    }
    else if (event.keyCode == KEY_CODE_DOWN)
    {
        this._moveCursorUpOrDown(false);
        event.preventDefault();
    }
    else if (event.keyCode == KEY_CODE_ENTER)
    {
        if (this.isShown)
        {
            this._getActiveRow().click();
        }
        else
        {
            this.processSearchQuery();
        }

        event.preventDefault();
    }
    else if (event.keyCode == KEY_CODE_TAB)
    {
        if (this.preventDefaultTabMoving)
        {
            event.preventDefault();
            return false;
        }
        else if (this.isShown)
        {
            this._getActiveRow().click();
        }
    }
    else
    {
        this._processSearchQueryWithDelay(200);
    }
};

CitiesSearchController.prototype._moveCursorUpOrDown = function(isUp)
{
    if (!this.userActivitiesEnabled)
    {
        return;
    }

    var activeRow = this._getActiveRow();
    var switchTo = isUp ?
                   activeRow.prev(".row") : activeRow.next(".row");

    if (switchTo.length == 1)
    {
        this._setActiveRow(switchTo);
        this.hoverEnabled.switchValue(); // don't react to mouse move while changing active row the other way
    }
};

CitiesSearchController.prototype._setActiveRow = function(row)
{
    this._getActiveRow().removeClass("active");
    row.addClass("active");
};

CitiesSearchController.prototype._getActiveRow = function()
{
    return this._getContainer().find(".row.active");
};

CitiesSearchController.prototype._processSearchQueryWithDelay = function(delay)
{
    this._stopTimer();
    this.searchDelayTimer = setTimeout($.proxy(this.processSearchQuery, this), delay);
};

/**
 * Start search request
 */
CitiesSearchController.prototype.processSearchQuery = function()
{
    var newQuery = $.trim(this.searchField.val());

    if (newQuery == '')
    {
        this.hide();
    }
    else
    {
        this.onStartSearchCallback();
        this.autocompliteService.getPlacePredictions(
            {
                input: newQuery,
                types: ['(cities)'], // get only cities
                sessionToken: sessionTokenStore.getToken()
            },
            $.proxy(this._onSearchRequestCompleted, this)
        );
    }
};

/**
 * Process request to get detailed information about city
 * @param city
 */
CitiesSearchController.prototype.processGetDetailedCityInformation = function(city)
{
    var self = this;
    this.placesService.getDetails(
        {
            placeId: city.place_id,
            fields: ['place_id', 'geometry'],
            sessionToken: sessionTokenStore.getToken()
        },
        function(detailedCity, status)
        {
            if (status == window.google.maps.places.PlacesServiceStatus.OK)
            {
                self.onSelectedRowAction({
                    name: city.terms[0].value, // set original searched name (detailedCity contains localed city name)
                    place_id: detailedCity['place_id'],
                    geometry: detailedCity['geometry']
                });
            }
            else
            {
                self._onErrorRequest(status);
            }
            self.hide();
        }
    );

    // Session is invalid as soon as we get details
    sessionTokenStore.clearToken()
};

/**
 * callback on request completed
 * @param data search result
 * @param status status of request
 * @private
 */
CitiesSearchController.prototype._onSearchRequestCompleted = function(data, status)
{
    var container  = this._getContainer();
    container.empty();

    var isNormalResult = false;
    if (status == window.google.maps.places.PlacesServiceStatus.OK)
    {
        this._appendCitiesRows(data, container);
        isNormalResult = true;
    }
    if (status == window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS)
    {
        container.append(this._getEmptyResultRow());
        isNormalResult = true;
    }

    if (isNormalResult)
    {
        this.onRequestSuccessCallback();
        container.append(this._getPanelFooter()); // add footer for (powered by google)
        this.show();
    }
    else
    {
        this._onErrorRequest(status);
        this.hide();
    }
};

CitiesSearchController.prototype._onErrorRequest = function(status)
{
    console.error("Google places api response status: " + status);
    this.onRequestErrorCallback();
};

CitiesSearchController.prototype._stopTimer = function()
{
    clearTimeout(this.searchDelayTimer);
};



// WEBPACK FOOTER //
// ./web/js/controls/CitiesSearchController.js